import Vue from 'vue';
// import { COURSE_EVENTS } from '../../values/events';
import { SectionsProvider } from '../../providers/sections.provider';
import { TYPE_BOARD_DRAFT_RESPONSE_OPTIONS, TYPE_TEXT_DRAFT_RESPONSE_OPTIONS } from '@/content/values/sections';
import KEYS from '@/values/keys';
import { SectionMixin } from '@/courses/mixins/section.mixin';
import EdSectionObjectHomeworkInfo from '@/courses/components/ed-section-object-homework-info/ed-section-object-homework-info.vue';
import ToolService from '@/providers/tools';
import { IParamsModalConfirmation } from '@/plugins/ed-modal/interfaces/params-modal-confirmation.interface';
import Moment from 'moment';
import { SCREEN_MIRRORING_EVENTS } from '@/values/screen.mirroring.values';
import EdPresentationModeUsers from '@/content/components/ed-presentation-mode/ed-presentation-mode-users/ed-presentation-mode-users.component.vue';
import EdPresentationModeShareToggle from '@/content/components/ed-presentation-mode/ed-presentation-mode-share-toggle/ed-presentation-mode-share-toggle.component.vue';
import { COURSE_EVENTS } from '@/content/values/events';
import { COURSES_EVENTS } from '@/courses/values/courses-events.values';
import { SECTION_TYPES } from '@/content/values/sections';

export default Vue.component('ed-section-object', {
  components: {
    EdSectionObjectHomeworkInfo,
    EdPresentationModeUsers,
    EdPresentationModeShareToggle
  },
  props: {
    hasHomeworkInfo: Boolean,
    parentId: Number,
    level: Number,
    minDate: String,
    showTeacherOnly: {
      type: Boolean,
      default: true
    },
    isProject: {
      type: Boolean,
      default: false
    },
    isTaggedObject: {
      type: Boolean,
      default: false
    },
    tooltip: {
      type: String,
      default: ''
    },
    isDeckObject: {
      type: Boolean,
      default: false
    },
    onOpenDeck: {
      type: Function,
      default: null
    },
    hideOptions: {
      type: Boolean,
      default: false
    }
  },
  mixins: [
    SectionMixin
  ],
  data: () => {
    return {
      selected: false,
      objectID: '',
      isLoading: false,
      projectAdded: null
    }
  },
  computed: {
    loading() {
      return this.isLoading || this.section.loading
    },
    membersConnected() {
      return this.$store.state.AppStore.membersPosition.filter(m => {
        return (
          m.courseId == this.courseID &&
          m.classId == this.classID &&
          m.sectionId == this.section.sectionId
        );
      });
    },
    classes() {
      let padding = `edg-pad-left--${this.level * 10}`;
      return {
        'ed-section-object--edition':  this.options.editable,
        'edg-cur--grab':  this.options.draggable,
        'edg-cur--pointer': this.options.selectable,
        'ed-section-object--selected': this.options.selectable && this.selected,
        [padding]: true
      }
    },
    nameSectionStyle() {
      let nameSectionStyle = this.options.editable ? {
        maxWidth: `calc(100% - ${this.level * 20}px)`
      } : {};
      return nameSectionStyle
    },
    nameStyle() {
      return { maxWidth: `calc(100% - ${(this.membersConnected.length * 15)}px` };
    },
    teacherOnly() {
      let parent = SectionsProvider.getSectionByID(this.course?.sections, this.parentId);
      if(parent) {
        return parent.teacherOnly ? parent.teacherOnly : this.section.teacherOnly;
      } else {
        return false;
      }
    },
    escapedName() {
      return ToolService.exitSpecialChars(this.section.name);
    },
    isBoardHomework() {
      return this.section.homework && this.isDraftResponseOption(this.section);
    },
    currentPresentationSection() {
      return this.$store.state.MeetingsStore.currentPresentationSection.current;
    },
    isTextObject() {
      return this.section.type === SECTION_TYPES.LESSON_TEXT.code;
    }
  },
  methods: {
    changeObject() {
      let optionSelected =  this.section.type;
      switch(optionSelected) {
        case SECTION_TYPES.LESSON_EXTERNAL_LINK.code:
        case SECTION_TYPES.LESSON_VIDEO.code:
        case SECTION_TYPES.LESSON_IMAGES.code:
          this.$EdModal.createModal(
            SECTION_TYPES[this.section.type].modal,
            SectionsProvider.getParamsToSaveSection(
              this.$i18n.t('common.edit'),
              this.courseID,
              this.parentId,
              this.section.sectionId,
              optionSelected,
              this.section.name,
              true,
              this.classID
            )
          );
        break;
        case SECTION_TYPES.CARD.code:
          this.goToDeck(this.section.id, true);

          setTimeout(() => {
            this.$Courses.$emit(COURSES_EVENTS.OPEN_DECK_EDITOR, this.section);
          }, 100);
        break;
        default:
          this.$EdModal.createModal(
            SECTION_TYPES[optionSelected].modal, {
              parentId: this.parentId,
              courseId: this.courseID,
              classId: this.classID,
              edition: true,
              minDate: this.minDate,
              section: this.section
            }
          );
        break;
      }
    },

    async removeObject() {
      let data = {sectionId: this.section.sectionId,
      courseId: this.courseID , classId: this.classID};
      this.isLoading = true;
      if(this.section.resolved) {
        this.$EdModal.createConfirmationModal(
          {
            body: this.$i18n.t('courses.objects.confirmRemove'),
            action: async () => {
              await this.removeSection(data);
              this.isLoading = false;
            },
            secondAction: () => {
              this.isLoading = false;
            }
          }
        );
      } else {
        await this.removeSection(data);
        this.isLoading = false;
      }
    },
    setSelected({ sectionId, courseId = -1 , classId}) {
      if(this.options.selectable) {
        let classIdCondition: boolean = this.options.editable ? true : classId == this.classID;
        if(this.courseID == courseId && classIdCondition) {
          if(this.isDeckObject)
            this.selected = this.section.id === sectionId;
          else
            this.selected = this.section.sectionId === sectionId;
        }
      }
    },
    openObject(emitScreenMirroringEvent : boolean = true) {
      if(this.options.selectable && this.currentPresentationSection.sectionId !== this.section.sectionId) {
        let dataPreview = {sectionId: this.section.sectionId , courseId: this.courseID , classId: this.classID, title: this.course.title};
        if(this.isDeckObject) {
          this.$emit('onOpenDeck', this.section.id);
        } else {
          this.goToSectionPreview(dataPreview);
        }

        if(!this.options.editable) {
          this.setSectionInStorage(this.section.sectionId);
        }
      }

      if( emitScreenMirroringEvent ) {
        var target = this.target(SCREEN_MIRRORING_EVENTS.ON_OPEN_SECTION_OBJECT);
        this.$edEventBus.$emit(SCREEN_MIRRORING_EVENTS.CLICK, this, {target:target});
      }
    },
    target(screenMirroringEventName:string) {
      return screenMirroringEventName.replace('{sectionId}', this.section.sectionId);
    },
    async copyObject() {
      if(this.section.submissionDates) {
        if(this.section.submissionDates.dueDate) {
          let sectionDueDate = Moment(this.section.submissionDates.dueDate);
          let currentDate = Moment(Moment().format('YYYY-MM-DD'));
          if(currentDate > sectionDueDate) {
            let params: IParamsModalConfirmation = {
              body: this.$i18n.t('courses.objects.copyWithDueDate'),
              actionText: this.$i18n.t('common.accept'),
              firstLoadingIsDone: true,
              action: async () => {
                await this.goToCopy();
                this.$EdModal.closeModal();
              }
            };
            this.$EdModal.createConfirmationModal(params);
            return;
          }
        }
      }
      this.goToCopy();
    },
    async goToCopy() {
      try {
        this.isLoading = true;
        let sectionCopied = await this.$Courses.Store.copySectionA({
          sectionID: this.section.sectionId,
          parentID: this.parentId,
          moveSection: true,
          courseId: this.courseID,
          classId: this.classID
        })
        await this.$Courses.Store.reorderSectionA({
          section: sectionCopied,
          parentId: this.section.parentId,
          place: this.section.sectionId,
          courseId: this.courseID,
          classId: this.classID
        });
        let data = {sectionId: sectionCopied.id, parentId: this.parentId ,
        courseId: this.courseID , classId: this.classID};
        await this.goToRefreshSectionsTree(data);
        this.isLoading = false;
      } catch(err) {
        this.isLoading = false;
      }
    },
    async changeVisible() {
        try {
          this.isLoading = true;
          await this.setTeacherOnlySection(
            this.courseID,
            this.section.sectionId,
            this.classID
          );
          await this.checkParentTeacherOnly(
            this.courseID,
            this.course.sections,
            this.section,
            this.parentId,
            this.classID
          );
          this.isLoading = false;
        } catch(err) {
          this.isLoading = false;
          this.$EdModal.createMessageModal({
            title: this.$i18n.t('courses.errors.errorTitle'),
            body: this.$i18n.t('courses.errors.errorSavingObject'),
            type: KEYS.EVENT_TYPES.DANGER
          });
        }
    },
    addToProject(objectId){
      this.$edEventBus.$emit(COURSE_EVENTS.ADD_OBJECT_PROJECT, objectId)
      this.projectAdded = objectId
    },
    removeFromProject(objectId){
      this.$edEventBus.$emit(COURSE_EVENTS.REMOVE_OBJECT_PROJECT, objectId)
      this.projectAdded = null;
    },
    setProjectsAdded(projects) {
      this.projectAdded = projects.filter(el => el == this.section.sectionId)[0];
    },
    async removeDeckObjectConfirm(){
      this.$EdModal.createConfirmationModal(
        {
          body: this.$i18n.t('deck.confirmRemoveCard'),
          action: async () => {
            this.removeDeckObject();
          }
        }
      );
    },
    async removeDeckObject() {
      this.procesing = this.section.id;

      await this.$Courses.Store.removeCardA({
        cardSectionId: this.section.id,
        deckSectionId: this.section.parentId,
        courseId: this.courseID,
        classId: this.classID});

      await this.$Courses.Store.refreshDeckA({
        sectionId: this.section.parentId,
        courseId: this.courseID,
        classId: this.classID});

      this.$Courses.$emit(COURSES_EVENTS.DECK_CARD_REMOVED);
      this.procesing = 0;
    },
    isDraftResponseOption(section): boolean {
      return section?.type && (TYPE_BOARD_DRAFT_RESPONSE_OPTIONS.includes(section.type) || TYPE_TEXT_DRAFT_RESPONSE_OPTIONS.includes(section.type));
    }
  },
  created() {
    this.objectID = `${KEYS.PRE_OBJECT_ID}${this.section.sectionId}`;
    this.$edEventBus.$on(COURSE_EVENTS.OBJECT_SELECTED, this.setSelected);
    this.$edEventBus.$on(this.target(SCREEN_MIRRORING_EVENTS.ON_OPEN_SECTION_OBJECT), (args:any) => { this.openObject(false); });
    this.$edEventBus.$on(COURSE_EVENTS.SET_OBJECT_PROJECTS, this.setProjectsAdded);
  },
  beforeDestroy(): void {
    this.$edEventBus.$off(this.target(SCREEN_MIRRORING_EVENTS.ON_OPEN_SECTION_OBJECT));
  }
});
